import { createFileRoute } from "@tanstack/react-router"
import { projectSettingsAttachmentViewStaticData } from "src/views/ProjectSettingsAttachmentsView/constants"
import { ProjectSettingsAttachmentView } from "src/views/ProjectSettingsAttachmentsView/ProjectSettingsAttachmentView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/attachments",
)({
	component: ProjectSettingsAttachmentView,
	staticData: projectSettingsAttachmentViewStaticData,
})
